import * as React from "react";
import { Link } from "react-router-dom";
export var PageFooter = function () {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "clear"
  }), /*#__PURE__*/React.createElement("div", {
    className: "footer grid-100 c-footer"
  }, /*#__PURE__*/React.createElement("div", {
    className: "prodwidth gridreplace center l-container h-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "grid-100 text-center push-bottom c-footer__links"
  }, /*#__PURE__*/React.createElement(Link, {
    rel: "nofollow noopener",
    to: "/page/imprint/"
  }, "Impressum / Kontakt"), /*#__PURE__*/React.createElement(Link, {
    rel: "nofollow noopener",
    to: "/page/agb/"
  }, "AGB"), /*#__PURE__*/React.createElement(Link, {
    rel: "nofollow noopener",
    to: "/page/datenschutz/"
  }, "Datenschutz"), /*#__PURE__*/React.createElement("a", {
    rel: "nofollow noopener",
    href: "https://www.vxcash.net/?" + window.ladd,
    target: "_blank"
  }, "Webmasterprogramm"), /*#__PURE__*/React.createElement("a", {
    rel: "nofollow noopener",
    href: "https://www.vxmodels.com?" + window.ladd,
    target: "_blank"
  }, "Model werden"), /*#__PURE__*/React.createElement("a", {
    rel: "nofollow noopener",
    href: "https://www.flibzee.com/BAS/Videochat?" + window.ladd,
    target: "_blank"
  }, "Webcams mit Chat"), /*#__PURE__*/React.createElement("a", {
    rel: "nofollow noopener",
    href: "https://www.flibzee.com/BAS/CasualDating?" + window.ladd,
    target: "_blank"
  }, "Casual Dating"), /*#__PURE__*/React.createElement("a", {
    href: "#",
    "data-cc": "c-settings"
  }, "Cookie Einstellungen")), /*#__PURE__*/React.createElement("div", {
    className: "grid-100 text-center"
  }, /*#__PURE__*/React.createElement("small", null, "Copyright \u00A9 ", new Date().getFullYear(), " - beianrufsex.com \u2764 Telefonsex & Telefonerotik mit kostenloser Webcam | Made with \u2764 by Bei Anruf Sex")))));
};